export const ar_translations = {
  translation: {
    menu: {
      go_menu: 'الذهاب إلى القائمة',
      select_lang: 'اختر اللغة',
      suggestions_of_the_moment: 'اقتراحات اللحظة',
      wifi: 'واي فاي',
      cookie_preferences: 'تفضيلات ملفات تعريف الارتباط',
      feedback_form: 'أرسل لنا ملاحظاتك',
      google_rating: 'قيّمنا على جوجل'
    },
    general: {
      yes: 'نعم',
      no: 'لا',
      waitstaff_confirm_message: 'هل أنت متأكد من أنك تريد استدعاء النادل؟',
      call_waitstaff: 'استدعاء النادل',
      calling_waitstaff_successful: 'تم إرسال إشعارك.',
      error: 'خطأ!',
      basket: 'السلة',
      my_basket: 'سلتي',
      basket_text: 'يمكنك طلب المنتجات الموجودة في سلتك.',
      no_product: 'لا توجد منتجات في سلتك.',
      order: 'اطلب',
      clear_basket: 'إفراغ السلة',
      add_to_cart: 'أضف إلى السلة',
      service_closed: 'الخدمة مغلقة',
      service_between: 'يُقدَّم بين {{start_hour}} و {{end_hour}}',
      product_detail_sub_title: 'يمكنك تقديم طلب بإضافة المنتجات إلى سلتك..',
      total: 'المجموع',
      save: 'حفظ',
      cancel: 'إلغاء',
      name: 'الاسم',
      note: 'ملاحظة',
      send: 'إرسال',
      required_field: 'هذا الحقل اختيار إلزامي!',
      successfully_added_to_cart: 'تمت إضافة المنتج إلى سلتك بنجاح!',
      successfully_submitted: 'تم الإرسال بنجاح!',
      please_required_fields: 'يرجى ملء الحقول الإلزامية!',
      name_field_cannot_empty: 'لا يمكن ترك حقل الاسم فارغًا!',
      determine_the_product_quantity: 'حدد كمية المنتج.',
      maximum_number_of_selections: 'الحد الأقصى لعدد الاختيارات:',
      minimum_number_of_selections: 'الحد الأدنى لعدد الاختيارات لـ {{item}} هو {{quantity}}',
      ssid: 'اسم الواي فاي',
      password: 'كلمة المرور',
      cookie_title: 'سياسة ملفات تعريف الارتباط',
      cookie_text: 'يرجى تحديد تفضيلك بشأن جمع ملفات تعريف الارتباط.',
      cookie_info: 'إعلام',
      cookie_info_text: 'تعمل ملفات تعريف الارتباط على تحسين تجربتك في نظامنا.',
      accept: 'قبول',
      reject: 'رفض',
      your_choice_saved: 'تم حفظ اختيارك!',
      ok: 'حسناً',
      allow_location_access: 'السماح بالوصول إلى الموقع',
      you_can_order_if_you_allow_location_access: 'يمكنك الطلب إذا سمحت بالوصول إلى الموقع!',
      search_all_products: 'ابحث في جميع المنتجات...',
      description: 'الوصف',
      all_items_delete_in_basket: 'سيتم حذف جميع العناصر الموجودة في السلة!',
      delete: 'حذف',
      successful: 'تم بنجاح!',
      delete_the_product: 'أنت على وشك حذف المنتج!',
      order_failed: 'فشل الطلب!',
      outside_order_border: 'لا يمكن تنفيذ الطلب لأنك خارج حدود الطلب!',
      waitstaff_call_failed: 'فشل استدعاء النادل!',
      outside_waitstaff_border: 'لا يمكن استدعاء النادل لأنك خارج الحدود!',
      you_can_call_waitstaff_if_you_allow_location_access: 'يمكنك استدعاء النادل إذا سمحت بالوصول إلى الموقع!',
      order_transmitted: 'تم إرسال الطلب!',
      enjoy_your_meal: 'لقد وصلنا طلبك. بالهناء والشفاء!',
      minute: 'د',
      select: 'اختر',
      required_selections: 'اختيارات إلزامية',
      optional_selections: 'اختيارات اختيارية',
      calorie: 'سعرة',
      sold_out: 'نفذت الكمية',
      this_product_sold_out: 'هذا المنتج نفذت كميته.',
    },
    labels: {
      new: 'جديد',
      star: 'مقبلات',
      chefs_suggestion: 'تقديم خاص',
    }
  }
}